export const releases = [
  { version: '0.4.0', entityId: '95ws3h6s3gov6bbqaemomk4vs' },
  { version: '0.5.0', entityId: '23wsp40vamzq0gkzeyka6zg3l' },
  { version: '0.6.0', entityId: 'b90oy0hmad20vshx7msol6591' },
  { version: '0.6.1', entityId: '896o7olq2ozaz871iud1f58h0' },
  { version: '0.7.0', entityId: '9g05gmqhrjjoelyg31gyjrtn1' },
  { version: '0.8.0', entityId: '5z3tpiz6b2qmdnhl6wio9h355' },
  { version: '0.9.0', entityId: '2mswirvu6bthu1i2ac0hrmzcu' },
  { version: '0.10.0', entityId: '6cx7szzcksgg1xini116tn4bn' },
  { version: '0.11.0', entityId: 'cps42si6kl8eawo9fs4sp5kx4' },
  { version: '0.12.0', entityId: '1f364549lqkg7u1t04h3qdatr' },
  { version: '0.13.0', entityId: 'ak4c4h14gb2vrd1i9vbor586h' },
  { version: '0.14.0', entityId: '3tw6zsnw6wlmf7afuvznk7crj' },
  { version: '0.15.0', entityId: '1a5vd458rky7b79wewdf386t1' },
  { version: '0.16.0', entityId: '7vc5ndpt12xqi6ua2ykqot0sy' },
  { version: '0.17.0', entityId: 'ay8826g846bgudrxp2vgdus8m' },
  { version: '0.18.0', entityId: 'muh1rzxqf22uelv7u82foepa' },
  { version: '0.19.0', entityId: '7zpfgao7ph3mso4njh5w7bulb' },
  { version: '0.20.0', entityId: '2ygjz18v7qq8cjg7cab3nsrgn' },
  { version: '0.21.0', entityId: 'c18ykixivij1h8z4jmwdlxl5i' },
]
